import React from "react";
import './LoadingScreen.css'
const LoadingScreen = () => {
  return (
    <>
      <div className="center">
        <div className="loader"></div>
      </div>
    </>
  );
};

export default LoadingScreen;
